import DownloadIcon from '@mui/icons-material/Download';
import { Stack, Typography } from '@mui/material';
import PaiButton from 'features/ui/base-components/pai-button';
import PaiDropzone from 'features/ui/base-components/pai-dropzone';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  addInvitationsCSV(event: React.SyntheticEvent): void;
  addInvitationsCSVFromDrop(files: File[]): void;
  csvLoading: boolean;
}

const CsvUploadField: React.FC<Props> = ({ addInvitationsCSV, addInvitationsCSVFromDrop, csvLoading }) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const inputId = React.useId();

  const handleTemplateDownload = () => {
    const template = 'email,lastName,firstName\njohn.doe@example.com,Doe,John\njane.smith@example.com,Smith,Jane';
    const blob = new Blob([template], { type: 'text/csv;charset=utf-8;' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'invitation-template.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <Stack gap={1.5}>
      <Typography className={classes.text}>{t('uploadCSVFile')}</Typography>
      <PaiDropzone maxWidth={'100%'} height={'180px'} onDrop={addInvitationsCSVFromDrop} />
      <Stack direction={'row'} gap={1} alignItems={'center'} flexWrap={'wrap'}>
        <input accept={'.csv'} style={{ display: 'none' }} id={inputId} type={'file'} onChange={addInvitationsCSV} />
        <label htmlFor={inputId}>
          <PaiButton text={csvLoading ? t('csvUploadLoading') : t('csvUploadAction')} size={'small'} border={'rounded'} disabled={csvLoading} />
        </label>
        <PaiButton
          text={t('csvUploadDownloadTemplate')}
          size={'small'}
          border={'rounded'}
          color={'secondary'}
          startIcon={<DownloadIcon />}
          disabled={csvLoading}
          action={handleTemplateDownload}
        />
      </Stack>
      <Typography className={classes.text} fontWeight={'bold'}>
        {t('uploadExample')}
      </Typography>
      <Typography className={classes.text}>{t('csvUploadHintHeaderOptional')}</Typography>
    </Stack>
  );
};

const useStyles = makeStyles()((theme) => ({
  text: {
    fontSize: theme.typography.pxToRem(13),
  },
}));

export default CsvUploadField;
